<script setup>
import {inject} from "vue";
import SecuredBadge from "./SecuredBadge.vue";
import FileList from "./FileList.vue";
const { file_filter } = inject('filter');

const { CHANNEL_PRIVATE, CHANNEL_PUBLIC, channel_selected, selectChannel } = inject('channel');

const {fileList} = defineProps(['fileList']);
const emit = defineEmits(['openInModal']);

const openInModal = function ({file,href,title,confidential}) {
  emit('openInModal', {file,href,title,confidential});
};
</script>

<template>
  <FileList v-for="(file, index) in fileList.list" :file-data="file" :open-file-id="fileList.open_file_id" :channel="channel_selected" @share-link="shareLink" @open-in-modal="openInModal"></FileList>

  <router-link :to="{ name: 'private.camera_cards' }" v-if="fileList.channels.camera_cards.length > 0 && CHANNEL_PRIVATE === channel_selected && fileList.depth < 2 && !file_filter.search.active" class="list-group-item list-group-item-action icon-link overflow-x-hidden px-lg-4 px-sm-1 py-2">
    <i class="icon bi me-lg-4 me-sm-2 project"></i>
    Camera Cards
    <SecuredBadge :class="['position-relative','float-end','top-50','translate-middle', 'secured','position-absolute', 'end-0']" />
  </router-link>
</template>